

// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <input data-controller="date" />

import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    new Cleave(this.element, {
      date: true,
      delimiter: '-',
      datePattern: ['m', 'd', 'Y']
    });
  }
}
